import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import { grey } from "@material-ui/core/colors";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Typography from "@material-ui/core/Typography";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CloseIcon from "@material-ui/icons/Close";
import DonutLarge from "@material-ui/icons/DonutLarge";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import PersonIcon from "@material-ui/icons/Person";
import SecurityIcon from "@material-ui/icons/Security";
import React, { useEffect, useState } from "react";
import { CgArrowsExchangeAltV } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import useResizer from "../../services/useResizer";
import useWindowDimensions from "../../services/useWindowDimensions";
import CollapsibleListItem from "./CollapsibleListItem/index";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import PaymentIcon from "@material-ui/icons/Payment";
import Switch from "@material-ui/core/Switch";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import { isFirefox } from "react-device-detect";
import { AppBar, Divider, Hidden, Toolbar } from "@material-ui/core";
import { HiMenu } from "react-icons/hi";
import LogoWhite from "../../assets/img/mainLogoLight.svg";
import MobileNavbarDrawer from "../MobileNavbarDrawer";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

import "./index.scss";
import { useDialog } from "../../contexts/DialogProvider";

export default function Navbar(props) {
  const [openDialog, closeDialog] = useDialog();
  const classes = useStyles();
  let history = useHistory();
  const dispatch = useDispatch();
  const darkMode = useSelector((state) => state.trading.DARK_MODE);
  const [collapse, setCollapse] = useState({});
  const token = useSelector((state) => state.trading.TOKEN);
  const isLoggedIn = Boolean(token);
  const mobileApp = useSelector((state) => state.trading.IS_USING_MOBILE_APP);
  const userProfile = useSelector((state) => state.trading.USER_PROFILE);
  const isMobile = useResizer();
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 50;

      setScroll(scrollCheck);
    });
  });

  const handleThemeChange = () => {
    dispatch({ type: "SET_DARK_MODE", payload: !darkMode });
  };

  function handleLogout() {
    // console.log("Logging out");
    dispatch({ type: "SET_TOKEN", payload: null });
    dispatch({ type: "SET_TOKEN_STATUS", payload: null });
    dispatch({ type: "SET_LOGIN_ID", payload: null });

    window.fcWidget.user.clear();
    history.push(`/login`);

    // window.location.reload();
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function pageNotAvailablePopup() {
    openDialog({
      children: (
        <>
          <DialogTitle>Coming Soon</DialogTitle>
          <DialogContent>
            <Typography>
              This page will be available soon! Stay tuned.
            </Typography>
          </DialogContent>
          <DialogActions
            style={{ paddingBottom: "30px", paddingRight: "20px" }}
            className="flex flex-wrap md:flex-nowrap"
          >
            <Button
              variant="contained"
              onClick={() => {
                closeDialog();
              }}
              className="mb-4 md:mb-0 text-sm"
              color="primary"
              style={{ color: "white", fontWeight: "bold" }}
            >
              Okay
            </Button>
          </DialogActions>{" "}
        </>
      ),
    });
  }
  const options = [
    { label: "Trade", subItems: [], link: "/trade/BTC" },
    {
      label: "Earn",
      subItems: [
        { label: "Vault", subItems: [], link: "/vault", pill: "16.5% APY" },
        { label: "Refer & Earn", subItems: [], link: "/login" },
      ],
    },
    { label: "Fees", subItems: [], link: "/feespage" },
    {
      label: "Company",
      subItems: [
        {
          label: "About Us",
          subItems: [],
          link: "/aboutus",
        },
        {
          label: "Blog",
          subItems: [],
          link: "https://pocketbits.in/blog/",
        },
        {
          label: "Media Mentions",
          subItems: [],
          // link: "/login",
          onClick: () => {
            pageNotAvailablePopup();
          },
        },
        {
          label: "Updates & Notifications",
          subItems: [],
          link: "https://feed.pocketbits.in/en",
        },
      ],
    },
    {
      label: "Support",
      subItems: [
        {
          label: "FAQs",
          subItems: [],
          link: "https://support.pocketbits.in/support/solutions",
        },
        {
          label: "Create Support Ticket",
          subItems: [],
          link: "https://support.pocketbits.in/support/tickets/new",
        },
        {
          label: "Contact Us",
          subItems: [],
          link: "https://pocketbits.in/contactus",
        },
      ],
    },
  ];
  return (
    <nav className={classes.root}>
      <div
        className={`${classes.tool}  transition-all py-2 ${
          scroll || history.location.pathname != "/" ? "navbar-scrolled" : ""
        } ${isFirefox && "bg-[#444]"}`}
      >
        <div
          className="flex items-center -ml-3 md:-ml-0"
          onClick={() => {
            history.push(`/`);
          }}
        >
          <img
            src={LogoWhite}
            className={classes.mainLogo}
            alt="PocketBits"
          ></img>
        </div>
        <Hidden smDown>
          <div className="flex items-center  text-white md:ml-32 ">
            <ul>
              {options.map((ele, idx) => (
                <li className="">
                  <div
                    className="title flex items-center noSelect cursor-pointer"
                    onClick={() => {
                      if (ele.link) {
                        if (ele.link?.includes("http")) {
                          window.open(ele.link, "_blank");
                        } else {
                          history.push(ele.link);
                        }
                      }
                    }}
                  >
                    <div className="mr-1">{ele.label}</div>
                    {Boolean(ele.subItems) && ele.subItems.length > 0 && (
                      <ArrowDropDownIcon
                        style={{ width: "16px" }}
                      ></ArrowDropDownIcon>
                    )}
                  </div>
                  {Boolean(ele.subItems) && ele.subItems.length > 0 && (
                    <div class="dropdown">
                      <ul className="flex flex-col ">
                        {ele.subItems.map((subItem, idx) => (
                          <li>
                            <a
                              href="javascript:void(0)"
                              className="cursor-pointer noSelect"
                              onClick={() => {
                                if (subItem.onClick) {
                                  subItem.onClick();
                                }
                                if (subItem.link) {
                                  if (subItem.link?.includes("http")) {
                                    window.open(subItem.link, "_blank");
                                  } else {
                                    history.push(subItem.link);
                                  }
                                }
                              }}
                            >
                              <div className="flex items-center gap-x-2">
                                <p>{subItem.label}</p>
                                {subItem?.pill && (
                                  <div className="px-2 rounded-md  new-pill font-bold">
                                    {subItem.pill}
                                  </div>
                                )}
                              </div>
                              <div className="arrow ">
                                <ArrowForwardIcon></ArrowForwardIcon>
                              </div>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </Hidden>
        {/* Only for desktop */}
        <Hidden smDown>
          <div>
            {token == null && (
              <div className="flex flex-nowrap ">
                <div
                  className="flex items-center gap-x-2 bg-pb-primary-100  shimmer-auto   py-2 px-4 rounded-lg text-white w-max font-bold hover:bg-[#1e886a] transition-all cursor-pointer mr-3"
                  onClick={() => {
                    history.push("/createacc");
                  }}
                >
                  <img
                    src={
                      require("../../assets/optimized/Landing/Hero Section/Navbar Icons/createAnAccount-icon.svg")
                        .default
                    }
                  ></img>
                  CREATE AN ACCOUNT
                </div>
                <div
                  className="flex items-center gap-x-2 bg-[#303030] mr-3   py-2 px-4  rounded-lg text-white w-max font-bold hover:bg-[#222] transition-all cursor-pointer"
                  onClick={() => {
                    history.push("/login");
                  }}
                >
                  {" "}
                  <img
                    src={
                      require("../../assets/optimized/Landing/Hero Section/Navbar Icons/signIn-icon.svg")
                        .default
                    }
                  ></img>
                  SIGN IN
                </div>
              </div>
            )}
          </div>
        </Hidden>
        {/* Only for mobiles */}
        <Hidden smUp>
          <div className="flex justify-between">
            {token == null && (
              <>
                <div
                  className="flex items-center gap-x-2 bg-pb-primary-100 px-3 py-2  rounded-lg text-white w-max font-semibold hover:bg-[#1e886a] transition-all cursor-pointer mr-3"
                  onClick={() => {
                    history.push("/login");
                  }}
                >
                  SIGN IN
                </div>
              </>
            )}
            <div
              className=" flex items-center gap-x-2  bg-[#303030] px-3 py-2   rounded-lg text-white w-max font-semibold hover:bg-[#222] transition-all cursor-pointer"
              onClick={() => {
                history.push(`/trade/BTC`);
              }}
            >
              TRADE
            </div>
            <div
              onClick={props.handleDrawerOpen}
              className="pl-2 pr-2 flex items-center justify-center  cursor-pointer"
            >
              <HiMenu className="text-white" size={30}></HiMenu>
            </div>
          </div>
        </Hidden>
      </div>

      <MobileNavbarDrawer
        open={props.open}
        handleDrawerOpen={props.handleDrawerOpen}
        handleDrawerClose={props.handleDrawerClose}
      ></MobileNavbarDrawer>
    </nav>
  );
}

const useStyles = makeStyles((darkTheme, isMobile) => ({
  root: {
    flexGrow: 1,
    top: 0,

    // minWidth: "450px",
    position: "fixed",
    width: "100vw",
    zIndex: "999",
  },
  menuButton: {
    // marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  mainLogo: {
    "&:hover": {
      cursor: "pointer",
    },
    width: "100%",
    minWidth: "130px",
    maxWidth: "160px",
  },
  tool: {
    top: 0,
    width: "100vw",
    padding: "0px 8px",
    height: "50px",
    display: "flex",
    justifyContent: "space-between",

    // [theme.breakpoints.up("md")]: {
    //   paddingLeft: "34px",
    //   paddingRight: "34px",
    // },
    // <div className={classes.content}>{props.children}</div>
  },
}));

// import { makeStyles } from "@material-ui/core";
// import React, { useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";
// import LogoWhite from "../../assets/img/mainLogoLight.svg";

// const useStyles = makeStyles((theme) => ({
//   mainLogo: {
//     "&:hover": {
//       cursor: "pointer",
//     },
//     width: "100%",
//     minWidth: "150px",
//     maxWidth: "160px",
//   },
// }));

// export default function LandingPageNavbar(props) {
//   const classes = useStyles();
//   const history = useHistory();
// const [scroll, setScroll] = useState(false);

// useEffect(() => {
//   document.addEventListener("scroll", () => {
//     const scrollCheck = window.scrollY > 50;

//     setScroll(scrollCheck);
//   });
// });

//   return (
//     <div
// className={`fixed flex justify-between px-3 py-1 items-center w-full transition-all  ${
//   scroll && "navbar-scrolled"
// }`}
//       style={{ zIndex: "99" }}
//     >
//       <div
//         className="flex items-center -ml-3 md:-ml-0"
//         onClick={() => {
//           history.push(`/`);
//         }}
//       >
//         <img
//           src={LogoWhite}
//           className={classes.mainLogo}
//           alt="PocketBits"
//         ></img>
//       </div>
//       <div className="flex items-center ">
//         {" "}
//         <div
//           className="bg-[#303030] mr-3 py-2 md:px-8 px-4 rounded-lg text-white w-max font-bold hover:bg-opacity-50 transition-all cursor-pointer"
//           onClick={() => {
//             history.push("/trade/BTC");
//           }}
//         >
//           TRADE
//         </div>
// <div
//   className="hidden md:block bg-[#303030] mr-3  md:px-8 py-2 px-4  rounded-lg text-white w-max font-bold hover:bg-opacity-50 transition-all cursor-pointer"
//   onClick={() => {
//     history.push("/createacc");
//   }}
// >
//   CREATE AN ACCOUNT
// </div>
// <div
//   className="bg-pb-primary-100  md:px-8 py-2 px-4 rounded-lg text-white w-max font-bold hover:bg-opacity-50 transition-all cursor-pointer"
//   onClick={() => {
//     history.push("/login");
//   }}
// >
//   SIGN IN
// </div>
//       </div>
//       <style>
//         {`
//         .navbar-scrolled{
//              background-color: rgba(0,0, 0, 0.01);
// backdrop-filter: blur(20px) saturate(160%) contrast(45%) brightness(100%);
// -webkit-backdrop-filter: blur(20px) saturate(160%) contrast(45%) brightness(140%);

//           }`}
//       </style>
//     </div>
//   );
// }
